import {Link, NavLink} from "react-router-dom";
import {CommentOutlined, GroupOutlined, HomeOutlined, ScheduleOutlined, StockOutlined} from "@ant-design/icons";
import {useTranslation} from "react-i18next";
import {useOrganization} from "../context/organizationContext";
import {useEffect, useState} from "react";
import {useSelector} from "react-redux";


const AppNavigation = () => {
	const org = useOrganization();
	const user = useSelector((obj) => obj.auth.user);

	const {t} = useTranslation();
	const items = [
		{
			condition: true,
			label: t("home.homeNavTitle"),
			key: 'home',
			icon: <HomeOutlined className='text-[24px] md:!text-[28px]' />,
			path: '/home'
		},
		{
			condition: true,
			label: t("home.contentPlanNavTitle"),
			key: 'contentPlan',
			icon: <ScheduleOutlined className='text-[24px] md:!text-[28px]' />,
			path: '/content-plan'
		},
		{
			condition: true,
			label: t("home.createPostNavTitle"),
			key: 'createPost',
			icon: <GroupOutlined className='text-[24px] md:!text-[28px]' />,
			path: '/posts'
		},
		{
			condition: true,
			label: t("home.personalAssistantNavTitle"),
			key: 'personalAssistant',
			icon: <CommentOutlined className='text-[24px] md:!text-[28px]' />,
			path: '/assistant'
		},
		{
			condition: user.strategiesCount > 10 && !org?.organization?.id,
			// condition: true,
			label: t("home.strategyNavTitle"),
			key: 'strategy',
			icon: <StockOutlined className='text-[24px] md:!text-[28px]' />,
			path: '/personal-brand'
		},
	];
	const [currentItems, setCurrentItems] = useState(items);


	useEffect(() => {
		setCurrentItems(
				items.filter((item) => item.condition)
		);
	}, [user, org, org?.organization?.id]);

	return null;

	return (
			<div className='h-16 md:h-20 fixed border-t p-1 left-0 bottom-0 bg-primary-gradient w-full flex justify-center items-center gap-2 z-50'>
				<div className='w-full max-w-xl flex justify-between gap-2'>
					{currentItems.map((item) => (
						item.condition &&
						<NavLink
							key={item.key}
							to={item.path}
							className={({ isActive }) =>
								'h-14 md:h-16 w-full flex flex-col items-center justify-center gap-1 p-1 rounded-lg ' +
								`${isActive ? 'text-[#9ad3f2] bg-white shadow-inner shadow-black/25' : 'text-white'}`
							}
						>
							{item.icon}
							<span className='text-[9px] md:text-[10px] font-medium text-center line-clamp-1'>
								{item.label}
							</span>
						</NavLink>
					))}
				</div>
			</div>
	);
};

export default AppNavigation;